import { Button, UIHeading4, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './AuthNotification.css';
// @ts-expect-error TODO: исправить импорт картинок
import chatImage from './assets/chat.png';

type TAuthNotificationProps = {
  onAuthClick(): void;
};

export const AuthNotification: React.VFC<TAuthNotificationProps> = ({ onAuthClick }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['notification']}>
        <img src={chatImage} width={100} height={100} />
        <UIHeading4>Войдите, чтобы писать сообщения</UIHeading4>
        <UIText1 textAlign="center" color="gray60_100">
          Сможете переписываться
          <br />с другими пользователями Циан
        </UIText1>
        <Button onClick={onAuthClick}>Вход или регистрация</Button>
      </div>
    </div>
  );
};
